import type { ComponentType } from 'react';

export const layoutsMap: Record<
  string,
  () => Promise<{ default: ComponentType }>
> = {
  MainLayout: () => import('./main/MainLayout/MainLayout'),
  HomepageLayout: () => import('./homepage-layout'),
  EmptyLayout: () => import('./EmptyLayout')
};
